<!--清除cookie-->
<template>
  <div class="views-clear-cookie">
  	<!-- header头 -->
    <div class="header">
      <div class="title">清除cookie</div>
    </div>
    <!-- 内容区 -->
    <div class="container">
      <div class="clear-cookie" @click="clearCookie">点击此处清除cookie</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: '',
  data() {
    return {
      name: '',
    }
  },
  computed: {
    
  },
  methods: {
    clearCookie() {
      this.$cookie.delete('p-appid');
      this.$cookie.delete('p-openId');
      this.$cookie.delete('placeOrderParams');
      this.$cookie.delete('p-userId');
      this.$cookie.delete('p-accessToken');
      this.$cookie.delete('p-insId');
      this.$cookie.delete('p-pageId');
      alert('清除成功')
    }
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .header
    width: 100%
    height: 1rem
    line-height: 1rem
    background-color: #fff
    color: #333
    text-align: center
    font-size: .34rem
    position: absolute
    top: 0
    left: 0
    display: flex
    z-index: 99
    border-bottom: 1px solid #f5f5f5
    .title
      width: 100%
      text-align: center
  .container
    padding-top: 1rem
    .clear-cookie
      width: 50%;
      margin: 0 auto;
      text-align: center
      font-size: .3rem
      color: #f60;
      margin-top: 1rem;
      padding: .1rem
      border: 1px solid #f60;
      border-radius: .1rem;
</style>
